import { render } from "./ActivationFailure.vue?vue&type=template&id=e4f34eae"
import script from "./ActivationFailure.vue?vue&type=script&lang=js"
export * from "./ActivationFailure.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__